import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'
import * as promoCodeActions from '@prepler/core/lib/actions/admin/promoCodeActions'
import {format} from '@prepler/core/lib/constants/dateTime'
import routesHelper from '@prepler/core/lib/routesHelper'

const PromoCode = ({promoCode, actions: {destroyAdminPromoCode}}) => {
	const {id, value, from, to} = promoCode;
	return <tr>
		<td>{id}</td>
		<td>{value}</td>
		<td>{from && format(from)}</td>
		<td>{to && format(to)}</td>
		<td>
			<Link to={{pathname: routesHelper.adminPromoCodeEditPath({id})}} className="btn btn-default" style={{marginRight: '8px'}}>
				Edit
			</Link>
			<a className="btn btn-danger" onClick={(e) => {
				e.preventDefault();
				window.confirm('Are you sure?') && destroyAdminPromoCode(promoCode)
			}} style={{marginRight: '8px'}}>Delete</a>
		</td>
	</tr>;
};

function mapStateToProps(state, ownProps) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(promoCodeActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PromoCode);

